<template>
 <div class="listDecisionTree">
     <main class="t-main">
       <ol class="m-breadcrumb">
         <li class="m-breadcrumb__item"><span class="a-text">決定木一覧</span></li>
       </ol>
       <h1 class="a-title">{{ listDecisionTreeTitle }}</h1>
       <div class="m-form__item-wrapper">
         <div class="m-form__item m-form__item--50">
           <label class="m-form__label">datasourceId<span class="m-form__input--select-wrapper">
             <select
              class="m-form__input m-form__input--select"
              name="category"
              v-model="datasourceId"
              @change="changeDataSourceId"
             >
                <option
                  v-for="datasource in datasources"
                  v-bind:value="datasource.datasourceId"
                >
                  {{ datasource.datasourceId }}
                </option>
             </select>
           </span></label>
         </div>
       </div>
       <div v-if="datasourceId">
         <div class="m-form__item-wrapper">
           <button class="a-button" v-on:click="createDecisionTreeLink">新規登録</button>
         </div>
         <br/>
         <div class="a-section">
         <table class="m-table">
           <thead>
             <tr>
               <th>{{ columns.slug }}</th>
               <th>{{ columns.title }}</th>
               <th>{{ columns.description }}</th>
               <th>{{ columns.delete }}</th>
             </tr>
           </thead>
           <tbody>
             <tr v-for="task in tasks">
              <td><router-link v-bind:to="{ path: 'update-decision-tree', query: { datasourceId: datasourceId, treeId: task.treeId}}">{{ task.treeId }}</router-link></td>
              <td>{{ task.metadata.name }}</td>
              <td>{{ task.metadata.description }}</td>
              <td><a class="m-form__delete" v-on:click="deleteDecisionTree(task)"></a></td>
             </tr>
           </tbody>
         </table>
        </div>
      </div>
    </main>
  </div>
</template>

<script>

import store from '../../../stores'

export default {
  name: 'listDecisionTree',
  data() {
    const columns = { slug: 'slug', title: 'タイトル', description: '説明', delete: '削除' }
    return {
      listDecisionTreeTitle: '決定木一覧',
      columns,
      datasourceId: ''
    }
  },
  created() {
    store.dispatch('getDatasourceInListData')
    store.dispatch('getDecisiontreeListData', this.$route.query.datasourceId)
  },
  // ajaxで取得してきた
  computed: {
    tasks: { get() { return store.state.decisiontree.decisiontreelist } },
    datasources: { get() { return store.state.decisiontree.datasourceInList } }
  },
  methods: {
    callDecisionTreeList: function() {
      store.dispatch('decisiontreelist', this.tasks)
    },
    createDecisionTreeLink: function() {
      this.$router.push('/udata/create-decision-tree?datasourceId=' + this.datasourceId)
    },
    changeDataSourceId: function() {
      store.dispatch('getDecisiontreeListData', this.datasourceId)
      this.$router.push('/udata/list-decision-tree?datasourceId=' + this.datasourceId)
    },
    deleteDecisionTree: function(decisionTree) {
      if (confirm(decisionTree.datasourceId + 'に登録された' + decisionTree.decisionTreeId + 'のバージョン' + decisionTree.versionId + 'を削除しますか？')) {
        store.dispatch('decisionTreeDelete', decisionTree)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/udata/decisiontree/ListDecisionTree.vue